export const CustomMetrics = {
  name: 'Vexflow-Custom',
  smufl: false,
  glyphs: {}
};
